import { ISystemParameter } from "../../../model/systemparameter/SystemParameter";
import { DateService } from "../../../service/DateService";

export interface TSystemParameterPresentationModel {
  id: number;
  path: string;
  description: string;
  parameterType: string;
  valueVchar?: string;
  valueNumber?: number;
  valueInteger?: number;
  valueDateTime?: string;
  valueClob?: string;
  valueBoolean?: boolean;
}

const SystemParameterPresentationModel = (
  data: ISystemParameter
): TSystemParameterPresentationModel => {
  const valueDateTime = data.valueDateTime
    ? DateService().formatDate(data.valueDateTime)
    : undefined;
  return {
    id: data.id,
    path: data.path,
    description: data.description,
    parameterType: data.parameterType,
    valueVchar: data.valueVchar,
    valueNumber: data.valueNumber,
    valueInteger: data.valueInteger,
    valueDateTime,
    valueClob: data.valueClob,
    valueBoolean: data.valueBoolean
  };
};

export default SystemParameterPresentationModel;
